import Tools from "./tools";
let mobileReg = /^(09)[0|1|2|3|9][0-9]{8}$/gi,
  junkReg = /[^\d]/gi,
  persinNum = [
    /۰/gi,
    /۱/gi,
    /۲/gi,
    /۳/gi,
    /۴/gi,
    /۵/gi,
    /۶/gi,
    /۷/gi,
    /۸/gi,
    /۹/gi,
  ],
  num2en = function (str) {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persinNum[i], i);
    }
    return str;
  };
export function getMobiles(str) {
  let mobiles = num2en(str + "").match(mobileReg) || [];
  mobiles.forEach(function (value, index, arr) {
    arr[index] = value.replace(junkReg, "");
    arr[index][0] === "0" || (arr[index] = "0" + arr[index]);
  });
  return mobiles;
}

let phoneReg = /(0)\d{10}/gi;

export function getPhone(str) {
  let phone = num2en(str + "").match(phoneReg) || [];
  phone.forEach(function (value, index, arr) {
    arr[index] = value.replace(junkReg, "");
    arr[index][0] === "0" || (arr[index] = "0" + arr[index]);
  });
  return phone;
}

export function cellNumberValidation(phoneNumber) {
  let regex = /(?:^0?$|^09?$|^09)\d{0,9}$/g;
  return regex.test(Tools.toEnglish(phoneNumber));
}

export function phoneNumberValidation(phoneNumber) {
  let regex = /(?:^0?$|^0)\d{0,10}$/g;
  return regex.test(Tools.toEnglish(phoneNumber));
}

export function emailValidation(email) {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
}
